// Botones de identidad federada (Google). Filtra el provider `google`
// si la sesión viene de una app nativa que no debe mostrar Google login
// (ver NATIVE_APPS_WITH_SOCIAL_LOGIN). El click lleva debounce de 2s
// para evitar dobles submits si el usuario tabea rápido.
//
// rememberMe: estado del checkbox "Mantener la sesión iniciada" del
// LoginPage. Si viene definido, se añade remember_me=on|off al link del
// broker — FdGoogleIdentityProvider (providers/) lo traduce a la auth
// note estándar de Keycloak y la sesión Google sale recordada igual que
// con el form de usuario/contraseña. SIEMPRE explícito (on|off, nunca
// omitido) para que el provider distinga "usuario decidió que no" de
// "request sin información" (reintentos del broker, account linking).
// En páginas sin checkbox (registro) se deja undefined y no se añade nada.

import type { MouseEvent } from "react";
import type { KcDataSocialProvider } from "../kcData";
import { NATIVE_APPS_WITH_SOCIAL_LOGIN } from "../nativeApp";
import { msg } from "../i18n";

export interface SocialLoginsProps {
  socialProviders: KcDataSocialProvider[];
  nativeApp: string | null;
  rememberMe?: boolean;
}

export function SocialLogins({
  socialProviders,
  nativeApp,
  rememberMe,
}: SocialLoginsProps) {
  let providers = socialProviders;
  if (
    nativeApp &&
    !(NATIVE_APPS_WITH_SOCIAL_LOGIN as readonly string[]).includes(nativeApp)
  ) {
    providers = providers.filter((p) => p.alias !== "google");
  }

  let running = false;

  const guardClick = (e: MouseEvent<HTMLAnchorElement>) => {
    if (running) {
      e.preventDefault();
      return;
    }
    running = true;
    setTimeout(() => {
      running = false;
    }, 2000);
  };

  // El loginUrl del broker ya lleva query params (session_code, client_id,
  // tab_id...), así que casi siempre toca "&"; el ternario cubre el caso
  // improbable de una URL sin query.
  const brokerUrl = (loginUrl: string) =>
    rememberMe === undefined
      ? loginUrl
      : loginUrl +
        (loginUrl.includes("?") ? "&" : "?") +
        `remember_me=${rememberMe ? "on" : "off"}`;

  return (
    <div className="social-providers">
      <ul>
        {providers.map((p) => (
          <li key={p.alias}>
            <a
              href={brokerUrl(p.loginUrl)}
              id={`zocial-${p.alias}`}
              onClick={guardClick}
            >
              {msg("labelSocialProviders")}{" "}
              <div id={`custom-btn-${p.alias}`}>
                <span className="icon" />
                <span className="button-text">Google</span>
              </div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
